import React from 'react';
import { CheckCircleIcon, StarIcon, ArrowRightIcon, ClockIcon, PenToolIcon, LayoutIcon, SparklesIcon } from 'lucide-react';
export function SalesCopy() {
  return <div className="cosmic-bg" data-id="element-221">
      {/* Section - What's Included (Product Card) */}
      <section className="relative z-10 py-10 md:py-14 px-4" data-id="element-222">
        <div className="max-w-3xl mx-auto" data-id="element-223">
          {/* Section Header */}
          <div className="text-center mb-10" data-id="element-224">
            <div className="inline-flex items-center gap-2 bg-[#F5C842]/15 border border-[#F5C842]/30 rounded-full px-5 py-1.5 mb-5" data-id="element-225">
              <StarIcon className="w-4 h-4 text-[#F5C842]" data-id="element-226" />
              <span className="text-[#F5C842] font-bold text-sm uppercase tracking-wider" data-id="element-227">
                Para Astrólogas Profesionales
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-228">
              ¿Qué incluye el{' '}
              <span className="text-gold-gradient" data-id="element-229">Sistema Pro</span>?
            </h2>
            <p className="text-lg text-white/70 max-w-xl mx-auto" data-id="element-230">
              Dentro de{' '}
              <strong className="text-white" data-id="element-231">SISTEMA PRO CARTAS NATALES</strong>{' '}
              encontrás todo lo que necesitás para entregar informes
              profesionales con confianza.
            </p>
          </div>

          {/* Header */}
          <div className="text-center mb-8" data-id="element-232">
            <p className="text-white font-bold text-lg mb-2" data-id="element-233">
              ✦ LO QUE INCLUYE EL SISTEMA ✦
            </p>
            <p className="text-white/70 text-sm" data-id="element-234">
              6 tomos profesionales · Acceso inmediato · Descarga digital ·
              Listo para usar hoy
            </p>
          </div>

          {/* 6 Tomos - Individual Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-235">
            {/* Tomo 1 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-236">
              <div className="flex items-start gap-3 mb-3" data-id="element-237">
                <span className="text-3xl flex-shrink-0" data-id="element-238">📕</span>
                <div data-id="element-239">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-240">
                    TOMO 1
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-241">
                    Bienvenida & Perfil de la Clienta
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-242">
                55 páginas · El primer contacto que genera confianza inmediata
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-243">
                Incluye la carta de bienvenida personalizable, la ficha de datos
                natales completa, el cuestionario de intención de consulta y el
                perfil detallado del Sol, la Luna y el Ascendente para los 12
                signos.
              </p>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-244">
              <div className="flex items-start gap-3 mb-3" data-id="element-245">
                <span className="text-3xl flex-shrink-0" data-id="element-246">📗</span>
                <div data-id="element-247">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-248">
                    TOMO 2
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-249">
                    Los Planetas en Signos y Casas
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-250">
                60 páginas · El núcleo técnico de tu informe
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-251">
                Interpretaciones completas de Mercurio, Venus, Marte, Júpiter,
                Saturno, Urano, Neptuno, Plutón, Nodo Norte, Lilith y Quirón —
                en los 12 signos y en las 12 casas. Con tabla maestra de
                síntesis.
              </p>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-252">
              <div className="flex items-start gap-3 mb-3" data-id="element-253">
                <span className="text-3xl flex-shrink-0" data-id="element-254">📘</span>
                <div data-id="element-255">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-256">
                    TOMO 3
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-257">
                    Las 12 Casas Astrológicas
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-258">
                55 páginas · El mapa completo de la vida de tu clienta
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-259">
                Análisis profundo de cada casa con su signo en la cúspide, los
                planetas que la habitan, la interpretación del regente y la
                síntesis narrativa. Las 12 áreas de vida listas para entregar.
              </p>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-260">
              <div className="flex items-start gap-3 mb-3" data-id="element-261">
                <span className="text-3xl flex-shrink-0" data-id="element-262">📙</span>
                <div data-id="element-263">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-264">
                    TOMO 4
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-265">
                    Aspectos y Configuraciones Especiales
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-266">
                60 páginas · Los patrones más profundos del alma
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-267">
                Conjunciones, trígonos, sextiles, cuadraturas, oposiciones y
                quincuncios — las 21 combinaciones más frecuentes. Más las
                configuraciones especiales: Stellium, Gran Trígono, T-Cuadrada,
                Cruz Cósmica y Yod.
              </p>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-268">
              <div className="flex items-start gap-3 mb-3" data-id="element-269">
                <span className="text-3xl flex-shrink-0" data-id="element-270">📔</span>
                <div data-id="element-271">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-272">
                    TOMO 5
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-273">
                    Síntesis Final & Mensaje del Alma
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-274">
                55 páginas · El corazón del informe
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-275">
                La síntesis completa: propósito de vida, dones y talentos,
                desafíos del alma, mundo del amor, misión profesional y ciclos
                actuales. Incluye la Carta del Alma y 7 afirmaciones únicas para
                cada clienta.
              </p>
            </div>

            {/* Tomo 6 */}
            <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-276">
              <div className="flex items-start gap-3 mb-3" data-id="element-277">
                <span className="text-3xl flex-shrink-0" data-id="element-278">📒</span>
                <div data-id="element-279">
                  <h3 className="text-gray-900 font-black text-base mb-1" data-id="element-280">
                    TOMO 6
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-281">
                    Manual de la Astróloga
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-xs font-semibold mb-2" data-id="element-282">
                50 páginas · Tu guía de uso y monetización
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-283">
                El manual exclusivo para dominar el sistema: flujo de trabajo
                paso a paso, checklists de calidad, técnicas de personalización,
                guía de precios y paquetes, 6 emails listos y estrategias para
                escalar tu práctica.
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-8" data-id="element-284">
            <a href="#comprar" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#F5C842] text-[#0f0a1e] font-bold px-8 py-3.5 rounded-full text-base hover:opacity-90 transition-opacity shadow-lg" data-id="element-285">
              Quiero el Sistema Completo <ArrowRightIcon className="w-5 h-5" data-id="element-286" />
            </a>
            <p className="text-white/60 text-sm mt-3" data-id="element-287">
              Acceso inmediato · Descarga digital · Listo para usar hoy
            </p>
          </div>
        </div>
      </section>

      {/* Feature Panels */}
      <section className="relative z-10 py-8 md:py-12 px-4" data-id="element-288">
        <div className="max-w-5xl mx-auto" data-id="element-289">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8" data-id="element-290">
            {/* Panel 1 - Ahorro de Tiempo */}
            <div className="flex flex-col items-center text-center" data-id="element-291">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center mb-4 shadow-lg shadow-blue-500/20" data-id="element-292">
                <ClockIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-293" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-294">
                Ahorro de Tiempo
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-295">
                No pierdas horas armando informes. Tenés todo listo para
                completar y entregar a tus clientas.
              </p>
            </div>

            {/* Panel 2 - 100% Editable */}
            <div className="flex flex-col items-center text-center" data-id="element-296">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mb-4 shadow-lg shadow-orange-500/20" data-id="element-297">
                <PenToolIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-298" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-299">
                100% Editable
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-300">
                Archivos editables para que puedas adaptarlos a tu estilo
                personal y a cada clienta.
              </p>
            </div>

            {/* Panel 3 - Diseño Profesional */}
            <div className="flex flex-col items-center text-center" data-id="element-301">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-rose-400 to-red-500 flex items-center justify-center mb-4 shadow-lg shadow-red-500/20" data-id="element-302">
                <LayoutIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-303" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-304">
                Diseño Profesional
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-305">
                Informes con apariencia premium que transmiten confianza y
                elevan tu imagen profesional.
              </p>
            </div>

            {/* Panel 4 - Versatilidad Total */}
            <div className="flex flex-col items-center text-center" data-id="element-306">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-purple-400 to-violet-600 flex items-center justify-center mb-4 shadow-lg shadow-violet-500/20" data-id="element-307">
                <SparklesIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-308" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-309">
                Versatilidad Total
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-310">
                Ideal para cualquier tipo de carta natal: solar, lunar,
                revolución, sinastría y más.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}